import React from "react";
import { withRouter } from "react-router-dom";
import { createUseStyles } from "react-jss";
import withDefaultParams from "Services/withDefaultParams";

const useStyles = createUseStyles(theme => ({
    root: {
        padding: "20px",
        fontFamily: theme.fonts.light,
        fontSize: "16px",
        lineHeight: "1.38",
        color: theme.palette.colors.darkSlateBlue,
        backgroundColor: theme.palette.colors.white,
        border: `solid 1px ${theme.palette.colors.disabled}`,
        borderRadius: "20px",
    },
    [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
        root: {
            fontSize: "14px",
            lineHeight: "1.29",
        },
    },
    [`@media (max-width: ${theme.media.sm})`]: {
        root: {
            fontSize: "14px",
            lineHeight: "1.29",
            margin: "0",
        },
    },
}));


const SeoTextRatesTags = props => {
    let {
        match: {
            params: { tagCode },
        },
        siteCode,
        region,
        tariffs,
        useTag,
    } = props;

    let classes = useStyles();

    const speedMeasure = () => {
        return `<span style="white-space: nowrap">Мбит/с</span>`;
    };

    const internetIMobilnayaSvyaz101 = () => {
        let tariffNameInternetSpeedMinList = !!tariffs.info
            .tariffNamesInternetSpeedMinList
            ? tariffs.info.tariffNamesInternetSpeedMinList.split(", ")
            : [];
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5)  providersNameList = providersNameList.slice(0, 5);

        return `
<p>Домашний интернет и мобильную связь можно смело отнести к одним из основных потребностей современного человека. Говоря о том, какой тариф домашнего интернета и мобильной связи выбрать, стоит отталкиваться от ваших запросов.</p>
<p>Если вы единственный пользователь сети, в основном используете интернет-подключение для просмотра фильмов и сериалов, редко скачиваете данные и пользуетесь облачными хранилищами — для вас ${
            tariffNameInternetSpeedMinList.length === 1
                ? "подойдет тариф"
                : "подойдут тарифы"
        } ${tariffs.info.tariffNamesInternetSpeedMinList} со скоростью ${
            useTag.internet.speedMin
        } ${speedMeasure()}.</p>
<p>Если у вас большая семья, множество различных устройств, нуждающихся в сетевом подключении или же вы часто загружаете в сеть большие массивы данных — обратите внимание на тарифы со скоростью подключения ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()}.</p>
<p>А для тех, кто любит общаться по телефону, приятным дополнением станут пакеты минут, которые можно потратить на общение с друзьями и близкими по всей России.</p>
<p>Вне зависимости от тарифа ${
            providersNameList.length !== 1 ? "провайдеры" : "провайдер"
        } ${providersNameList.join(", ")} ${
            providersNameList.length !== 1 ? "предлагают" : "предлагает"
        } вам:</p>
<ul >
    <li>хорошее покрытие сети по ${region.declinations.dative};</li>
    <li>высокое качество сигнала, без шумов и помех на линии;</li>
    <li>подключение к интернету без сбоев и зависаний.</li>
</ul>
<p>Выбрать тарифный план для подключения интернета и мобильной связи очень просто. Мы собрали все варианты в одном месте и теперь вам нужно только ввести название вашей улицы и номер дома, и вы увидите список выгодных тарифов мобильной связи с интернетом, доступных в вашем доме.</p>
<p>Оставить заявку на подключение понравившегося тарифа можно прямо на нашем сайте.</p>
    `;
    };

    const internetTvMobile101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Домашний интернет, ТВ и мобильная связь — это цифровая основа социальной и культурной жизни современного человека. В интернете и по ТВ мы узнаём новости и смотрим фильмы. В сети и по мобильной связи — общаемся с близкими. Что бы мы ни делали, хороший сигнал и стабильная связь важны всегда. Хорошо, что ${
            providersNameList.length !== 1 ? "провайдеры" : "провайдер"
        } ${providersNameList.join(", ")} в ${
            region.declinations.prepositional
        } ${
            providersNameList.length !== 1 ? "готовы" : "готов"
        } это обеспечить.</p>
<p>Остаётся только определиться, какой именно тариф интернета, ТВ, мобильной связи выбрать.</p>
<p>Всё зависит от ваших потребностей.</p>
<p>Если вы привыкли проводить много времени в интернете, скачивая и загружая большие объёмы данных — стоит обратить внимание на тарифы, в которых скорость подключения достигает ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>Если вы любите долгое общение по телефону, то вас заинтересуют тарифы, включающие ${
            useTag.mobile.countCallsType1 != 0
                ? "безлимитное количество"
                : `до ${useTag.mobile.callsMax}`
        } минут разговора в месяц.</p>
<p>Если же вы не представляете свою жизнь без телевидения, то вам точно понравятся тарифы, в которых доступно ${
            useTag.tv.channelMax
        } каналов, из них вы наверняка выберете для себя что-то интересное.</p>
<p>Какой бы тариф вы ни выбрали, в каждом из них вы получите:</p>
<ul>
    <li>доступ к интернету без зависаний и сбоев;</li>
    <li>качественную телефонную связь;</li>
    <li>доступ к ТВ каналам.</li>
</ul>
<p>Просто введите название вашей улицы и номер дома, и вы увидите все доступные для вас предложения в одной таблице.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте.</p>
    `;
    };

    const domashnijInternet101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        const textInternetOver100 = () => {
            return `<li>до ${
                useTag.internet.speedMax
            } ${speedMeasure()} — если активных пользователей сети много, то следует рассмотреть этот вариант, чтобы сигнала точно хватило на всех. Фильмы в лучшем качестве, быстрая загрузка больших объёмов данных, подключение множества устройств.</li>`;
        };

        return `
<p>Домашний интернет нужен практически всем. Если вы работаете или учитесь из дома, смотрите фильмы и сериалы в интернете, общаетесь по видеосвязи и в социальных сетях, используете различные устройства умного дома — вы точно заинтересованы в хорошем тарифе домашнего интернета.</p>
<p>Благодаря ${providersNameList.join(", ")} в ${
            region.declinations.prepositional
        } у вас есть множество вариантов для подключения интернета в доме или квартире. Но чем больше вариантов, тем сложнее выбрать. Именно поэтому мы собрали все предложения в одном месте. Теперь вам не придётся просматривать кучу разных сайтов.</p>
<p>Выберите для себя подходящую скорость подключения:</p>
<ul>
    <li>до 100 ${speedMeasure()} — для тех, кому интернет нужен для повседневных задач. Проверить почту, узнать погоду, посидеть в социальных сетях и посмотреть сериал;</li>
    ${useTag.internet.speedMax > 100 ? `${textInternetOver100()}` : ""}
</ul>
<p>Выбирайте подходящий тариф и платите ${
            useTag.price.priceMin != useTag.price.priceMax
                ? `от ${useTag.price.priceMin}`
                : ""
        } до ${
            useTag.price.priceMax
        } рублей в месяц, в зависимости от выбранной вами скорости подключения.</p>
<p>Чтобы было ещё удобнее, введите название вашей улицы и номер дома в соответствующее поле, и вы увидите предложения, которые доступны по вашему адресу.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
    `;
    };

    const internetITv101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Домашний интернет и телевидение являются главными источниками новостей в современном мире. Если вы хотите быть в курсе событий и вовремя узнавать всё самое важное, стоит позаботиться о выгодном тарифе интернета и ТВ.</p>
<p>Благодаря ${providersNameList.join(
            ", "
        )} у вас есть возможность подключить тариф, который включает не только высокоскоростное интернет-соединение, но и доступ к минимум ${
            useTag.tv.allChannelMin
        } каналам.</p>
<p>Скорость интернета ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${
            useTag.internet.speedMax
        } ${speedMeasure()} позволит вам комфортно проводить время в сети и не беспокоиться о том, что интернет зависнет в самый неподходящий момент.</p>
<p>А наличие ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `от ${useTag.tv.allChannelMin}`
                : ""
        } до ${
            useTag.tv.allChannelMax
        } каналов даёт возможность подобрать программу по своему вкусу.</p>
<p>Причины, почему стоит выбрать тариф с домашним интернетом и ТВ:</p>
<ul>
    <li>возможность оплачивать услуги в одном месте;</li>
    <li>выгодная цена от ${useTag.price.priceMin} рублей в месяц;</li>
    <li>одновременное подключение сразу двух необходимых услуг.</li>
</ul>
<p>Чтобы помочь вам с выбором, мы собрали все предложения в одном месте. Введите название вашей улицы и номер дома, и вы увидите все доступные варианты.</p>
<p>Для подключения тарифа оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternet101 = () => {
        let year = new Date().getFullYear();
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        let text = () =>
            `<p>Для большой семьи, где все активно используют интернет, подойдут варианты со скоростью до ${
                useTag.internet.speedMax
            } ${speedMeasure()}.</p>`;

        return `
<p>Мы все любим выгодные предложения. Особенно если речь идёт о подключении необходимой услуги. В ${year} году благодаря ${providersNameList.join(
            ", "
        )} вы можете выбрать самые выгодные тарифы домашнего интернета.</p>
<p>При подключении одного из тарифов по акции вы получите:</p>
<ul>
<li>высокую скорость интернета;</li>
<li>стабильное подключение;</li>
<li>квалифицированную помощь службы поддержки.</li>
</ul>
<p>Чтобы выбрать подходящий тарифный план, стоит учитывать, как вы планируете использовать сетевое подключение.</p>
<p>Если для вас самое главное — работа, учёба и общение с близкими в социальных сетях, отдайте предпочтение варианту со скоростью до 100 ${speedMeasure()}.</p>
${useTag.internet.speedMax > 100 ? text() : ""}
<p>Всегда непросто сделать выбор, особенно когда предложений много. Чтобы облегчить вашу задачу, мы собрали все тарифные планы в одном месте. Теперь вам осталось только ввести ваш адрес и перед вами появятся все доступные варианты.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100mbit101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Хорошая скорость подключения к сети — залог комфортной работы в интернете. Интернет со скоростью 100 ${speedMeasure()} позволит вам заниматься своими делами, учиться, читать новости и смотреть фильмы, не беспокоясь о том, что соединение зависнет.</p>
<p>Выбор провайдера домашнего интернета — это всегда непросто и отнимает много времени. Чтобы помочь вам найти лучший вариант, мы собрали все предложения ${providersNameList.join(
            ", "
        )} в ${region.declinations.prepositional} в одном месте.</p>
<p>Тариф со скоростью 100 ${speedMeasure()} является наиболее популярным вариантом у большинства пользователей, в том числе из-за цены, которая начинается всего от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>За эту стоимость вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
<p>Для того чтобы выбрать подходящий вариант, введите название вашей улицы и номер дома, и вы получите все доступные предложения в виде удобной таблицы.</p>
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300mbit101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Если у вас большая семья, в которой все активно используют интернет, то иногда могут возникать проблемы со скоростью подключения. Чтобы их избежать, вы можете подключить тариф домашнего интернета со скоростью 300 ${speedMeasure()}.</p>
<p>Интернет 300 ${speedMeasure()} — это возможность обеспечить комфортную работу в сети нескольким людям. Вы можете одновременно просматривать фильмы, работать, учиться и скачивать информацию. Скорости хватит на всё.</p>
<p>${providersNameList.join(
            ", "
        )} в состоянии обеспечить вам качественное соединение за выгодную цену всего от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Если вам необходимо:</p>
<ul>
<li>выходить в интернет с нескольких устройств для выполнения различных задач;</li>
<li>обеспечивать корректную работу системы умного дома;</li>
<li>постоянно выгружать в сеть и скачивать из неё большие массивы данных.</li>
</ul>
<p>То вам стоит подключить интернет 300 ${speedMeasure()}.</p>
<p>Чтобы выбрать подходящий тариф, вам достаточно просто ввести название вашей улицы и номер дома на нашем сайте, и вы увидите все доступные предложения в виде удобной таблицы.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet500mbit101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Если вы привыкли смотреть фильмы в высоком разрешении, то для вас очень важна хорошая скорость интернета. Домашний интернет 500 ${speedMeasure()} позволит вам смотреть кино в самом высоком качестве, не беспокоясь о том, что фильм зависнет.</p>
<p>Благодаря ${providersNameList.join(
            ", "
        )} у вас есть возможность доступа к сети со скоростью от 500 ${speedMeasure()} по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Оптоволоконный кабель сделает ваше соединение не только быстрым, но и стабильным. А значит, проблемы с сигналом не помешают вам работать или наслаждаться любимым фильмом.</p>
<p>Интернет со скоростью 500 ${speedMeasure()} — это:</p>
<ul>
<li>возможность скачивать большие объёмы данных за считаные минуты;</li>
<li>комфортное общение в видеозвонках с любым количеством участников.</li>
</ul>
<p>Чтобы вам не пришлось тратить своё время на анализ различных сайтов, мы собрали все предложения в одном месте. Теперь вам достаточно просто ввести название вашей улицы и номер дома, и все доступные тарифы с домашним интернетом 500 ${speedMeasure()} будут перед вами.</p>
<p>Чтобы подключить интернет 500 ${speedMeasure()} у себя в квартире, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatr101 = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Иногда хочется провести вечер дома за просмотром любимого фильма. Для тех, кто предпочитает смотреть фильмы и сериалы онлайн, ${providersNameList.join(
            ", "
        )} ${
            providersNameList.length == 1 ? "создал" : "создали"
        } тарифы домашнего интернета с возможностью доступа к одному из онлайн-кинотеатров.</p>
<p>Онлайн-сервисы по просмотру фильмов и сериалов предоставляют интернет-провайдерам возможность проводить акцию — бесплатный период доступа к одному из кинотеатров:</p>
<ul>
<li>Кинопоиск — онлайн-кинотеатр со множеством сериалов, в том числе и оригинального производства;</li>
<li>Amediateka — стриминговый сервис фильмов и сериалов. Показывает премьеры новых проектов HBO одновременно со всем миром;</li>
<li>Okko — российский стриминговый сервис;</li>
<li>Wink — мультимедийная платформа для просмотра фильмов и сериалов;</li>
<li>Megogo — медиасервис, который позволяет смотреть тв, кино, спортивные трансляции и прослушивать аудио;</li>
<li>KION — онлайн-кинотеатр для просмотра фильмов и сериалов. Показывает сериалы, снятые специально для KION;</li>
<li>Триколор Кино и ТВ — предоставляет доступ к более 160 онлайн-каналам;</li>
<li>PREMIER — сервис для просмотра сериалов, кинофильмов и спортивных трансляций;</li>
<li>МегаФон ТВ — актуальные спортивные мероприятия, широкий выбор фильмов и сериалов;</li>
<li>ivi — большой выбор фильмов и сериалов в хорошем качестве;</li>
<li>more.tv — огромный каталог, фильмов, сериалов и телепрограмм;</li>
<li>START — видеосервис с доступом к премьерам фильмов и сериалов;</li>
<li>Tvigle — онлайн-кинотеатр с фильмами и мультсериалами в хорошем качестве;</li>
<li>TVzavr.ru — просмотр кино и сериалов в режиме VoD;</li>
<li>Rutube — сервис для хостинга и просмотра видео;</li>
<li>viju — премьеры и эксклюзивные материалы от известных киностудий.</li>
</ul>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов и сериалов.</p>
<p>Мы собрали все подобные предложения в одном месте, и теперь вам осталось только ввести название вашей улицы и номер дома, чтобы увидеть все доступные варианты.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
        `;
    };

    const internetIMobilnayaSvyazMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>В многообразии различных тарифов домашнего интернета и мобильной связи очень легко запутаться. Именно поэтому мы собрали все предложения ${
            providersNameList.length !== 1 ? "провайдеров" : "провайдера"
        } ${providersNameList.join(
            ", "
        )} в одном месте и готовы помочь вам с выбором хорошего тарифа.</p>
<p>Прежде всего стоит обратить внимание на скорость подключения:</p>
<ul>
    <li>100 ${speedMeasure()} — хорошая скорость, которая подойдёт для решения повседневных задач в интернете;</li>
    <li>200-500 ${speedMeasure()} — такую скорость стоит выбирать тем, кто живёт не один и выходит в сеть со множества различных устройств;</li>
    <li>500 ${speedMeasure()} и выше — скорость интернет-подключения для настоящих киноманов, которые любят фильмы в самом высоком качестве, и любителей онлайн-игр, которым важна каждая секунда. Такое высокоскоростное соединение также необходимо тем, кто работает с большими объёмами данных и загружает их в сеть.</li>
</ul>
<p>Помимо отличного интернета в тарифах вы также получите ${
            useTag.mobile.callsMin != useTag.mobile.callsMax
                ? `от ${useTag.mobile.callsMin}`
                : ""
        } до ${useTag.mobile.callsMax} минут разговора и от ${
            useTag.mobile.smsMin
        } смс.</p>
<p>Таким образом, при подключении одного из тарифов с домашним интернетом и мобильной связью, вы получаете:</p>
<ul>
    <li>стабильный интернет на скорости ${
        useTag.internet.speedMin != useTag.internet.speedMax
            ? `от ${useTag.internet.speedMin}`
            : ""
    } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
    <li>пакет минут разговора для общения по всей России;</li>
    <li>выгодную цену всего от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>А чтобы ваш выбор стал ещё проще, введите название вашей улицы и номер дома в специальные поля, и вы увидите все предложения, доступные именно для вашего дома.</p>
<p>Оставить заявку на подключение понравившегося тарифа вы всегда можете прямо на нашем сайте.</p>
    `;
    };

    const internetTvMobileMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Пакет интернета, ТВ, мобильной связи — это отличная возможность подключить сразу всё необходимое для комфортной цифровой жизни современного человека. Выходите в сеть для работы или учёбы, смотрите любимые фильмы и программы по телевизору, общайтесь с близкими по телефону — ${
            providersNameList.length !== 1 ? "провайдеры" : "провайдер"
        } ${providersNameList.join(", ")} ${
            providersNameList.length !== 1 ? "позаботились" : "позаботился"
        } о том, чтобы это было комфортно и выгодно.</p>
<p>Вам осталось только выбрать, какой именно тариф интернета, ТВ, мобильной связи подключить.</p>
<p>Всё зависит от того, что именно для вас важно.</p>
<p>Если вы много работаете в интернете с большими массивами данных — лучше отдать предпочтение тарифам, в которых достигается максимальная скорость подключения ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>Если вам нужно много разговаривать по телефону — для вас есть тарифы, включающие ${
            useTag.mobile.countCallsType1 != 0
                ? "безлимитное количество"
                : `до ${useTag.mobile.callsMax}`
        } минут разговора в месяц.</p>
<p>Если же вы не представляете свою жизнь без просмотра телепередач — вам точно понравятся тарифы, в которых доступно ${
            useTag.tv.channelMax
        } каналов, из них вы наверняка выберете для себя подходящий.</p>
<p>Какой бы тариф вы ни выбрали, в каждом из них вас ждут:</p>
<ul>
    <li>доступ к интернету без зависаний и сбоев;</li>
    <li>качественная телефонная связь;</li>
    <li>доступ к каналам телевидения.</li>
</ul>
<p>Просто введите название вашей улицы и номер дома, и вы увидите все доступные для вас предложения в одной таблице.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте.</p>
    `;
    };

    const domashnijInternetMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>В наше время домашний интернет есть практически в каждой квартире. Сложно представить себе человека, которому для просмотра фильмов или сериалов, общения с друзьями и переписки в многочисленных чатах не был бы нужен интернет.</p>
<p>Поэтому вопрос, какой домашний интернет выбрать, для многих является таким важным и сложным, так как провайдеров и различных тарифов очень много.</p>
<p>Именно поэтому мы собрали все предложения ${providersNameList.join(
            ", "
        )} в одном месте. Теперь вам достаточно всего лишь зайти на наш сайт, ввести свой адрес и все доступные тарифы с домашним интернетом будут перед вами.</p>
<p>Выберите для себя подходящую скорость подключения:</p>
<ul>
    <li>до 100 ${speedMeasure()} — подойдёт тем, кому интернет нужен для повседневных задач. Проверить почту, узнать погоду, посидеть в социальных сетях и посмотреть сериал;</li>
    <li>от 100 ${
        useTag.internet.speedMax > 100 ? `до ${useTag.internet.speedMax}` : ""
    } ${speedMeasure()} — если активных пользователей сети будет много, то следует рассмотреть этот вариант, чтобы сигнала точно хватило на всех.</li>
</ul>
<p>Стоимость подключения тарифа с домашним интернетом начинается всего от ${
            useTag.price.priceMin
        } рублей в месяц. За эту цену вы получите:</p>
<ul>
    <li>отличный высокоскоростной интернет;</li>
    <li>подключение без сбоев и зависаний;</li>
    <li>оперативную поддержку провайдера.</li>
</ul>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
    `;
    };

    const internetITvMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Многих волнует вопрос — как выбрать хороший тариф интернета и телевидения? Ведь именно от качества подключения зависит, насколько удобным будет использование интернета и просмотр телевизора.</p>
<p>Обычно, чтобы выбрать хорошего провайдера, нужно просмотреть большое количество сайтов и потратить много времени. Чтобы вам не пришлось это делать, мы собрали всю информацию о ${providersNameList.join(
            ", "
        )} в одном месте.</p>
<p>Скорость интернета ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${
            useTag.internet.speedMax
        } ${speedMeasure()} позволит вам комфортно проводить время в сети и не беспокоиться о том, что интернет зависнет в самый неподходящий момент.</p>
<p>Наличие ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `от ${useTag.tv.allChannelMin}`
                : ""
        } до ${
            useTag.tv.allChannelMax
        } каналов даёт возможность подобрать программу по своему вкусу.</p>
<p>Тариф с домашним интернетом и ТВ это:</p>
<ul>
    <li>высокоскоростное интернет-соединение;</li>
    <li>доступ к большому количеству телевизионных каналов;</li>
    <li>выгодная цена от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Вам осталось только ввести название вашей улицы и номер дома, и вы увидите все актуальные тарифные планы.</p>
<p>Для подключения тарифа оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternetMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Дешёвый тариф с интернетом — это отличная возможность подключить нужную услугу по выгодной цене. Сетевое подключение необходимо постоянно, чем бы вы ни занимались. Работа, общение, изучение нового, просмотр фильмов, онлайн-игры — стабильный интернет нужен всегда.</p>
<p>Именно поэтому у ${providersNameList.join(
            ", "
        )} проводятся выгодные акции по подключению домашнего интернета. Это отличная возможность подключить качественный высокоскоростной интернет по хорошей цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>При этом вы получите:</p>
<ul>
<li>высокую скорость интернета;</li>
<li>стабильное подключение;</li>
<li>квалифицированную помощь службы поддержки.</li>
</ul>
<p>Подключите один из выгодных тарифов с интернетом и получите возможность просматривать фильмы, общаться в социальных сетях, читать новости — и всё это по доступной цене.</p>
<p>Всегда непросто сделать выбор, особенно когда вариантов много. Чтобы облегчить вашу задачу, мы собрали все предложения в одном месте. Теперь вам осталось только ввести ваш адрес и перед вами появятся все доступные тарифы.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100mbitMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>При выборе тарифа интернета для дома скорость является одним из определяющих факторов. Домашний интернет со скоростью 100 ${speedMeasure()} — это возможность заниматься делами, общаться, просматривать новости и смотреть фильмы в хорошем качестве.</p>
<p>Обычно, чтобы выбрать хороший тариф, нужно просмотреть множество сайтов, сравнить все варианты, проанализировать их. Всё это отнимает много времени. Чтобы вам не пришлось этого делать, мы собрали все предложения ${providersNameList.join(
            ", "
        )} в одном месте. Теперь вам достаточно просто ввести ваш адрес и все доступные варианты будут перед вами.</p>
<p>100 ${speedMeasure()} — это комфортная скорость, которой будет достаточно для выполнения всех повседневных задач. Подключить тариф с интернетом 100 ${speedMeasure()} можно по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>За эту стоимость вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300mbitMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Чем больше устройств подключается к сети, тем выше нужна скорость соединения, чтобы обеспечить корректную работу. Смартфоны, ноутбуки, компьютеры, устройства умного дома — подключите интернет 300 ${speedMeasure()} и скорости хватит для всего.</p>
<p>Каждому хочется иметь быстрый домашний интернет, о скорости которого не нужно беспокоиться. Оптоволоконный кабель позволяет предоставить подключение со скоростью от 300 ${speedMeasure()}.</p>
<p>Выбор тарифа от ${providersNameList.join(
            ", "
        )} обеспечит вам качественное соединение за выгодную цену от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Возможно, вам знакомы следующие ситуации:</p>
<ul>
<li>фильмы часто зависают на середине просмотра и приходится ждать, когда они загрузятся;</li>
<li>по вечерам, когда вся семья дома, интернет-страницы открываются очень долго;</li>
<li>скачивание данных растягивается на несколько часов.</li>
</ul>
<p>Со всеми этими трудностями может помочь подключение тарифа с интернетом 300 ${speedMeasure()}. Подберите для себя подходящий и забудьте обо всех проблемах, связанных с низкой скоростью интернета.</p>
<p>А чтобы вам было ещё проще, мы собрали все предложения в одном месте и вам осталось только ввести название вашей улицы и номер дома, и вы увидите все доступные варианты в виде удобной таблицы.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet500mbitMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Бывают моменты, когда необходима максимальная скорость интернета. Например, если вы любите играть в онлайн-игры, то вы знаете, что каждая секунда может стать решающей. Или если вам часто приходится загружать в облачные хранилища большие объёмы данных, и вы не хотите тратить на это несколько часов. Именно для вас созданы тарифы интернета со скоростью 500 ${speedMeasure()}.</p>
<p>У ${providersNameList.join(
            ", "
        )} есть возможность предоставить вам доступ к сети со скоростью от 500 ${speedMeasure()} по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Вам гарантируется не только быстрое, но и стабильное соединение, которое не прервётся и не зависнет. То есть ничего не помешает вашей работе, учёбе или другим занятиям в сети.</p>
<p>Зачем нужен интернет со скоростью 500 ${speedMeasure()}:</p>
<ul>
<li>возможность скачивать большие объёмы данных за несколько минут;</li>
<li>комфортное общение в видеозвонках с любым количеством участников;</li>
<li>возможность принимать участие в любых онлайн-играх.</li>
</ul>
<p>Чтобы вам не пришлось тратить своё время на анализ различных сайтов, мы собрали все предложения в одном месте. Теперь вам достаточно просто ввести название вашей улицы и номер дома, и все доступные тарифы с домашним интернетом 500 ${speedMeasure()} будут перед вами.</p>
<p>Чтобы подключить интернет 500 ${speedMeasure()} у себя в квартире, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatrMoskva = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Все любят посмотреть хороший фильм на большом экране, но в ритме современной жизни не всегда есть возможность посетить кинотеатр. Отличным выходом в такой ситуации станет онлайн-кинотеатр, в котором можно насладиться последними новинками или любимой классикой.</p>
<p>${providersNameList.join(
            ", "
        )} совместно с онлайн-сервисами по просмотру фильмов и сериалов проводят акцию — бесплатный период доступа к одному из онлайн-кинотеатров:</p>
<ul>
<li>Кинопоиск — онлайн-кинотеатр со множеством сериалов, в том числе и оригинального производства;</li>
<li>Amediateka — стриминговый сервис фильмов и сериалов. Показывает премьеры новых проектов HBO одновременно со всем миром;</li>
<li>Okko — российский стриминговый сервис;</li>
<li>Wink — мультимедийная платформа для просмотра фильмов и сериалов;</li>
<li>Megogo — медиасервис, который позволяет смотреть тв, кино, спортивные трансляции и прослушивать аудио;</li>
<li>KION — онлайн-кинотеатр для просмотра фильмов и сериалов. Показывает сериалы, снятые специально для KION;</li>
<li>Триколор Кино и ТВ — предоставляет доступ к более 160 онлайн-каналам;</li>
<li>PREMIER — сервис для просмотра сериалов, кинофильмов и спортивных трансляций;</li>
<li>МегаФон ТВ — актуальные спортивные мероприятия, широкий выбор фильмов и сериалов;</li>
<li>ivi — большой выбор фильмов и сериалов в хорошем качестве;</li>
<li>more.tv — огромный каталог, фильмов, сериалов и телепрограмм;</li>
<li>START — видеосервис с доступом к премьерам фильмов и сериалов;</li>
<li>Tvigle — онлайн-кинотеатр с фильмами и мультсериалами в хорошем качестве;</li>
<li>TVzavr.ru — просмотр кино и сериалов в режиме VoD;</li>
<li>Rutube — сервис для хостинга и просмотра видео;</li>
<li>viju — премьеры и эксклюзивные материалы от известных киностудий.</li>
</ul>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов и сериалов.</p>
<p>Мы собрали все подобные предложения в одном месте, и теперь вам осталось только ввести название вашей улицы и номер дома, чтобы увидеть все доступные варианты.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
        `;
    };

    const internetIMobilnayaSvyazPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>К выбору домашнего интернета стоит подходить очень ответственно. От того, насколько быстрым и стабильным будет подключение, зависит то, насколько комфортно вам будет работать и проводить время в сети.</p>
<p>${
            providersNameList.length !== 1 ? "Провайдеры" : "Провайдер"
        } ${providersNameList.join(", ")} ${
            providersNameList.length !== 1 ? "предоставляют" : "предоставляет"
        } тарифы с домашним интернетом и мобильной связью по цене всего от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Скорость подключения обычно первое, на что обращают внимание при выборе тарифа с домашним интернетом. Мы сделали короткую памятку для тех, кто не может определиться, какая скорость нужна:</p>
<ul>
    <li>выбирайте 100 ${speedMeasure()}, если вы используете интернет для повседневных задач, таких как работа, просмотр фильмов и чтение новостей;</li>
    <li>200-500 ${speedMeasure()} — для тех, у кого большая семья и доступ к интернету нужен со множества разных устройств;</li>
    <li>500 ${speedMeasure()} и выше — для тех, кто не любит себя ограничивать и хочет использовать возможности соединения по максимуму. Фильмы в высоком качестве, загрузка больших объёмов данных, скачивание игр — скорости хватит на всё.</li>
</ul>
<p>Помимо стабильного подключения к интернету вы также получите пакеты минут разговора от ${
            useTag.mobile.callsMin
        } минут в месяц, которые можно использовать на общение с друзьями и близкими по всей России.</p>
<p>Итак, выгодные тарифы мобильной связи с интернетом — это:</p>
<ul>
    <li>высокая скорость соединения ${
        useTag.internet.speedMin != useTag.internet.speedMax
            ? `от ${useTag.internet.speedMin}`
            : ""
    } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
    <li>стабильный телефонный сигнал без помех и посторонних шумов на фоне;</li>
    <li>возможность подключения сразу двух необходимых услуг одновременно;</li>
    <li>выгодная цена от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Сравнить все тарифы и выбрать для себя наиболее подходящий вы можете на нашем сайте. Для подключения необходимо оставить заявку и с вами обязательно свяжутся.</p>
    `;
    };

    const internetTvMobilePiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Подключение тарифа с интернетом, ТВ, мобильной связью — не только выгодно, но и удобно. Ведь это позволяет оплачивать все необходимые услуги одновременно и в одном месте. Подключив тариф с домашним интернетом, ТВ и мобильной связью, вы сможете наслаждаться любимыми программами, общаться с близкими, работать, играть в онлайн-игры, следить за новостями и всё это по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>${
            providersNameList.length !== 1 ? "Провайдеры" : "Провайдер"
        } ${providersNameList.join(", ")} ${
            providersNameList.length !== 1 ? "предоставляют" : "предоставляет"
        } широкий выбор и остаётся только решить, какой именно тариф интернета, ТВ, мобильной связи подходит именно вам.</p>
<p>Всё зависит от того, что именно для вас наиболее важно.</p>
<p>Если вы много работаете в интернете с большими массивами данных — лучше отдать предпочтение тарифам, в которых достигается максимальная скорость подключения ${
            useTag.internet.speedMax
        } ${speedMeasure()}.</p>
<p>Если вам нужно много разговаривать по телефону — для вас есть тарифы, включающие ${
            useTag.mobile.countCallsType1 != 0
                ? "безлимитное количество"
                : `до ${useTag.mobile.callsMax}`
        } минут разговора в месяц.</p>
<p>Если же вы не представляете свою жизнь без просмотра телевизора — вам точно понравятся тарифы, в которых доступно ${
            useTag.tv.channelMax
        } каналов, из них вы наверняка выберете для себя подходящий.</p>
<p>Какой бы тариф вы ни выбрали, в каждом из них вас ждут:</p>
<ul>
    <li>доступ к интернету без зависаний и сбоев;</li>
    <li>качественная телефонная связь;</li>
    <li>доступ к каналам телевидения.</li>
</ul>
<p>Введите название вашей улицы и номер дома, и вы увидите все доступные для вас предложения в одной таблице.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте.</p>
    `;
    };

    const domashnijInternetPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Рано или поздно с выбором домашнего интернета сталкивается каждый человек. Всем хочется получить хорошее подключение и не переплачивать. Но чем больше провайдеров появляется, тем сложнее становится выбор тарифа для подключения домашнего интернета.</p>
<p>Чтобы вам не пришлось тратить время на поиски информации, мы собрали все данные о ${providersNameList.join(
            ", "
        )} на нашем сайте. Вам осталось только ввести название вашей улицы и номер дома, и вы получите подборку всех доступных вариантов.</p>
<p>Выберите для себя подходящую скорость подключения:</p>
<ul>
    <li>до 100 ${speedMeasure()} — подойдёт тем, кому интернет нужен для повседневных задач;</li>
    <li>от 100 до 300 ${speedMeasure()} — идеальный вариант для большой семьи, где каждому нужно работать, смотреть фильмы, учиться;</li>
    <li>от 300 ${
        useTag.internet.speedMax > 300 ? `до ${useTag.internet.speedMax}` : ""
    } ${speedMeasure()} — для тех, кто привык использовать интернет по максимуму. Фильмы в самом высоком разрешении, скачивание файлов за считаные минуты.</li>
</ul>
<p>В любом выбранном тарифе вас ждут:</p>
<ul>
    <li>отличный высокоскоростной интернет;</li>
    <li>подключение без сбоев и зависаний;</li>
    <li>оперативная поддержка провайдера.</li>
</ul>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
    `;
    };

    const internetITvPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Стабильный интернет и хорошее ТВ — одни из составляющих комфортной и счастливой жизни. Если вы хотите наслаждаться любимыми телепрограммами, общаться в социальных сетях, играть в онлайн-игры и т.д., стоит задуматься о хорошем тарифе домашнего интернета и телевидения.</p>
<p>Чтобы вам не пришлось тратить время на поиск информации, мы собрали все данные о тарифных планах ${providersNameList.join(
            ", "
        )} в ${
            region.declinations.prepositional
        } в одном месте. Вам осталось только ввести название вашей улицы и номер дома, и все доступные тарифы появятся перед вами в виде удобной таблицы.</p>
<p>Выберите необходимую вам скорость подключения ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${
            useTag.internet.speedMax
        } ${speedMeasure()}. В любом случае соединение будет стабильным и надёжным.</p>
<p>Выбор из ${
            useTag.tv.allChannelMin != useTag.tv.allChannelMax
                ? `${useTag.tv.allChannelMin}-`
                : ""
        }${
            useTag.tv.allChannelMax
        } каналов позволит даже самому взыскательному человеку найти для себя что-то интересное.</p>
<p>Тариф с домашним интернетом и ТВ это:</p>
<ul>
    <li>высокоскоростное интернет-соединение;</li>
    <li>доступ к большому количеству телевизионных каналов;</li>
    <li>выгодная цена от ${useTag.price.priceMin} рублей в месяц.</li>
</ul>
<p>Для подключения тарифа оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
    `;
    };

    const nedorogojDomashnijInternetPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Выгодные тарифы домашнего интернета — это уникальные предложения от ${providersNameList.join(
            ", "
        )} в ${
            region.declinations.prepositional
        }. Подключите необходимую услугу по цене от ${
            useTag.price.priceMin
        } рублей в месяц. Стабильное качественное подключение — это гарантия комфортной работы в интернете. А проводимые акции — возможность ознакомиться с тарифом на выгодных условиях.</p>
<p>Подключите выгодный тариф с интернетом и получите:</p>
<ul>
<li>скорость подключения ${
            useTag.internet.speedMin != useTag.internet.speedMax
                ? `от ${useTag.internet.speedMin}`
                : ""
        } до ${useTag.internet.speedMax} ${speedMeasure()};</li>
<li>надёжное интернет-соединение без сбоев;</li>
<li>отличный сервис и внимательный подход к каждому клиенту.</li>
</ul>
<p>Выбирайте скорость подключения исходя из ваших потребностей и подключайте один из выгодных тарифов с интернетом прямо сейчас.</p>
<p>Чтобы немного облегчить вашу задачу, мы собрали все предложения в одном месте. Теперь вам осталось только ввести ваш адрес и перед вами появятся все доступные тарифы.</p>
<p>Чтобы подключить услугу, оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet100mbitPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Каждый рано или поздно сталкивается с проблемой выбора тарифа для домашнего интернета. У ${providersNameList.join(
            ", "
        )} есть идеальное решение — интернет-подключение со скоростью 100 ${speedMeasure()}. Данная скорость позволяет общаться с близкими по видеосвязи, смотреть фильмы и сериалы в высоком качестве, играть в онлайн-игры и скачивать данные.</p>
<p>Мы собрали все предложения на нашем сайте, чтобы вам не пришлось тратить своё время на поиски нужной информации. Вам осталось только ввести название вашей улицы и номер дома, и все доступные тарифы будут перед вами.</p>
<p>100 ${speedMeasure()} — это комфортная скорость, которой будет достаточно для выполнения всех повседневных задач. Подключить тариф с интернетом 100 ${speedMeasure()} можно по цене от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>За эту стоимость вы получите:</p>
<ul>
<li>надёжное сетевое подключение;</li>
<li>комфортную скорость для выполнения повседневных задач;</li>
<li>высокий уровень сервиса и помощь техподдержки.</li>
</ul>
<p>Для подключения достаточно оставить заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet300mbitPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Если вы привыкли активно использовать интернет, читать новости, смотреть фильмы, играть в онлайн-игры и использовать облачные сервисы, то интернет со скоростью 300 ${speedMeasure()} — это то, что вам нужно.</p>
<p>Каждому хотелось бы иметь быстрый домашний интернет, о скорости которого не приходится переживать, чем бы вы ни занимались. Скорость 300 ${speedMeasure()} особенно нужна тем, у кого большая семья или планируется установка системы умного дома. Ведь чем больше устройств одновременно подключаются к сети, тем хуже становится сигнал.</p>
<p>Благодаря ${providersNameList.join(
            ", "
        )} вам будет обеспечено качественное соединение за выгодную цену от ${
            useTag.price.priceMin
        } рублей в месяц.</p>
<p>Если вы часто сталкиваетесь с тем, что:</p>
<ul>
<li>видеозвонки не проходят или зависают на середине разговора, а изображение плохого качества;</li>
<li>по вечерам, когда вся семья дома, интернет-страницы открываются очень долго или не загружаются совсем;</li>
<li>скачивание данных растягивается на несколько часов.</li>
</ul>
<p>В таком случае вам стоит подключить тариф с интернетом 300 ${speedMeasure()}. Подберите для себя подходящий и забудьте обо всех проблемах, связанных с низкой скоростью интернета.</p>
<p>А чтобы вам было ещё проще, мы собрали все предложения в одном месте и вам осталось только ввести название вашей улицы и номер дома, и вы увидите все доступные варианты в виде удобной таблицы.</p>
<p>Оставить заявку на подключение можно прямо на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const internet500mbitPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>Если вы планируете установку системы умного дома, то наверняка задумывались о том, хватит ли вашей скорости интернета. Ведь чем больше устройств подключается к сети, тем выше должна быть скорость подключения, чтобы её хватило на все из них.</p>
<p>Именно поэтому у ${providersNameList.join(
            ", "
        )} существуют тарифные планы с возможностью доступа к сети на скорости от 500 ${speedMeasure()}.</p>
<p>Вам гарантируется не только быстрое, но и стабильное соединение, которое не прервётся и не зависнет. То есть вы будете уверены в корректной работе всех устройств.</p>
<p>Подключая интернет со скоростью 500 ${speedMeasure()}, вы получаете возможность:</p>
<ul>
<li>смотреть фильмы и сериалы в самом высоком качестве;</li>
<li>общаться по видеосвязи, наслаждаясь прекрасным и чётким изображением;</li>
<li>одновременно выходить в сеть с нескольких устройств, не мешая друг другу;</li>
<li>подключать большое количество устройств умного дома.</li>
</ul>
<p>Чтобы вам не пришлось тратить своё время на анализ различных сайтов, мы собрали все предложения в одном месте. Теперь вам достаточно просто ввести название вашей улицы и номер дома, и все доступные тарифы с домашним интернетом 500 ${speedMeasure()} будут перед вами.</p>
<p>Для подключения тарифа оставьте заявку на нашем сайте и с вами обязательно свяжутся.</p>
        `;
    };

    const onlineKinoteatrPiter = () => {
        let providersNameList = tariffs.providersName;
        if (providersNameList.length > 5) providersNameList = providersNameList.slice(0, 5);

        return `
<p>В последние годы сервисы онлайн-кинотеатров стали особенно популярны. Многие предпочитают не тратить время на походы в кинотеатр, а посмотреть фильм дома. Высокая скорость домашнего интернета в тарифах от ${providersNameList.join(
            ", "
        )} позволяет обеспечить прекрасное качество изображения.</p>
<p>Специально для любителей домашних киновечеров онлайн-сервисы предоставляют возможность проводить акцию — бесплатный период доступа к одному из кинотеатров:</p>
<ul>
<li>Кинопоиск — онлайн-кинотеатр со множеством сериалов, в том числе и оригинального производства;</li>
<li>Amediateka — стриминговый сервис фильмов и сериалов. Показывает премьеры новых проектов HBO одновременно со всем миром;</li>
<li>Okko — российский стриминговый сервис;</li>
<li>Wink — мультимедийная платформа для просмотра фильмов и сериалов;</li>
<li>Megogo — медиасервис, который позволяет смотреть тв, кино, спортивные трансляции и прослушивать аудио;</li>
<li>KION — онлайн-кинотеатр для просмотра фильмов и сериалов. Показывает сериалы, снятые специально для KION;</li>
<li>Триколор Кино и ТВ — предоставляет доступ к более 160 онлайн-каналам;</li>
<li>PREMIER — сервис для просмотра сериалов, кинофильмов и спортивных трансляций;</li>
<li>МегаФон ТВ — актуальные спортивные мероприятия, широкий выбор фильмов и сериалов;</li>
<li>ivi — большой выбор фильмов и сериалов в хорошем качестве;</li>
<li>more.tv — огромный каталог, фильмов, сериалов и телепрограмм;</li>
<li>START — видеосервис с доступом к премьерам фильмов и сериалов;</li>
<li>Tvigle — онлайн-кинотеатр с фильмами и мультсериалами в хорошем качестве;</li>
<li>TVzavr.ru — просмотр кино и сериалов в режиме VoD;</li>
<li>Rutube — сервис для хостинга и просмотра видео;</li>
<li>viju — премьеры и эксклюзивные материалы от известных киностудий.</li>
</ul>
<p>При выборе тарифа с подпиской на онлайн-кинотеатр у вас появляется замечательная возможность получить не только качественное интернет-соединение, но и доступ к множеству фильмов и сериалов.</p>
<p>Мы собрали все подобные предложения в одном месте, и теперь вам осталось только ввести название вашей улицы и номер дома, чтобы увидеть все доступные варианты.</p>
<p>Оставить заявку на подключение вы можете прямо на нашем сайте.</p>
        `;
    };

    let tagName101 = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyaz101,
        "internet-tv-mobile": internetTvMobile101,
        "domashnij-internet": domashnijInternet101,
        "internet-i-tv": internetITv101,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternet101,
        "internet-100-mbit": internet100mbit101,
        "internet-300-mbit": internet300mbit101,
        "internet-500-mbit": internet500mbit101,
        "online-kinoteatr": onlineKinoteatr101,
    };

    let tagNameMoskva = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyazMoskva,
        "internet-tv-mobile": internetTvMobileMoskva,
        "domashnij-internet": domashnijInternetMoskva,
        "internet-i-tv": internetITvMoskva,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternetMoskva,
        "internet-100-mbit": internet100mbitMoskva,
        "internet-300-mbit": internet300mbitMoskva,
        "internet-500-mbit": internet500mbitMoskva,
        "online-kinoteatr": onlineKinoteatrMoskva,
    };

    let tagNamePiter = {
        "internet-i-mobilnaya-svyaz": internetIMobilnayaSvyazPiter,
        "internet-tv-mobile": internetTvMobilePiter,
        "domashnij-internet": domashnijInternetPiter,
        "internet-i-tv": internetITvPiter,
        "nedorogoj-domashnij-internet": nedorogojDomashnijInternetPiter,
        "internet-100-mbit": internet100mbitPiter,
        "internet-300-mbit": internet300mbitPiter,
        "internet-500-mbit": internet500mbitPiter,
        "online-kinoteatr": onlineKinoteatrPiter,
    };

    let siteCodeName = {
        "101internet": tagName101,
        moskvaonline: tagNameMoskva,
        piteronline: tagNamePiter,
    };

    let seoTextView = siteCodeName[siteCode][tagCode];

    if (!!seoTextView && !!useTag) {
        return (
            <div className={classes.root}
                dangerouslySetInnerHTML={{
                    __html: seoTextView(),
                }}
            />
        );
    } else {
        return null;
    }
};

export default withRouter(withDefaultParams(SeoTextRatesTags));
